import { AxiosResponse } from "axios";
import API from "../api";

import { CompanyPort, Port } from "../models/port";

const endpoint = "ports";

const PortService = {
  async getAll(options?: any): Promise<AxiosResponse<Port[]>> {
    return await API.get(`/${endpoint}`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Port>> {
    return await API.get(`${endpoint}/${id}`, { params: options });
  },
  async update(id: number, data: Port): Promise<AxiosResponse<Port[]>> {
    return await API.put(`/${endpoint}/${id}`, data);
  },
  async switchStatus(data: CompanyPort): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/switch`, data);
  },
};

export default PortService;
